/*
 * Process Slate Shopify theme
 * Copyright 2018 Process Creative
 *
 * Version:
 *    1.0.0 - 2018/10/31
 */

'use strict';//Strict Mode enforced

import './../tools/Lazyloading';
import './../tools/Geo';

//Global objects
import './../objects/icon/Icon';
import './../objects/layout/TopBar';
import './../objects/richtext/Richtext';
import './../objects/terms-conditions/TermsConditions';
import './../objects/button/BackToTop';
import './../objects/button/ScrollDown';

//Global Components
import './../components/menu/AccountDropdown';
import './../components/popup/NewsletterPopup';
import './../components/popup/InternationalMessagePopup';
import './../components/optimize/SplitTest';

// Global (Theme) Sections
import './../sections/header/Header';
import './../sections/footer/Footer';
import './../sections/sale-promobar/SalePromobar';
import './../sections/gift/FreeGift';
import './../sections/cart/CartDrawer';
import './../sections/header/TabbedMenu';
